var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPwc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 111,
    viewBox: "0 0 147 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.981 47.6624H93.5256V34.0469H146.981V47.6624Z",
    fill: "#E669A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.038 47.6611H93.5256V13.6074H140.038V47.6611Z",
    fill: "#F3BE26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.822 47.6621H93.5256V0H120.822V47.6621Z",
    fill: "#EE9C34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.192 47.6622H93.5256V5.31836H126.192V47.6622Z",
    fill: "#F3BC87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5183 5.32617V47.6576H120.819V5.32617H93.5183Z",
    fill: "#E3721C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1543 47.6621H93.5257V54.4706H66.1543V47.6621Z",
    fill: "#AD1B02"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5183 13.6016V47.6584H126.207V13.6016H93.5183Z",
    fill: "#E88D14"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5183 13.6016V47.6584H120.819V13.6016H93.5183Z",
    fill: "#D85604"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.595 47.6622H93.5256V27.2227H110.595V47.6622Z",
    fill: "#C14303"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5183 34.0566V47.6581H140.054V34.0566H93.5183Z",
    fill: "#DB4E18"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5183 34.0566V47.6581H126.207V34.0566H93.5183Z",
    fill: "#D1390D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5183 34.0566V47.6581H120.819V34.0566H93.5183Z",
    fill: "#C22303"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5183 34.0566V47.6581H110.612V34.0566H93.5183Z",
    fill: "#AD1B02"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4771 73.3049C94.82 74.1288 92.3362 77.6304 92.3362 83.7068C92.3362 89.8863 95.6478 94.0059 100.512 94.0059C102.893 94.0059 104.962 93.1819 109.309 91.0191V96.0658C104.031 98.5373 100.926 99.1553 96.7864 99.1553C92.1291 99.1553 88.817 98.0225 86.2298 95.2418C83.5389 92.5639 82.09 89.0623 82.09 85.0455C82.09 76.2915 88.7136 70.2151 98.3386 70.2151C104.652 70.2151 109.102 73.2019 109.102 77.4245C109.102 80.2052 107.032 82.1621 104.031 82.1621C102.478 82.1621 101.236 81.6472 99.4769 80.7201L99.4771 73.3049ZM76.1909 85.0457C80.4341 79.7932 81.9867 77.6304 81.9867 75.0556C81.9867 72.4808 79.9167 70.2148 77.0189 70.2148C75.3629 70.2148 73.8107 71.1419 73.0862 71.9658V82.7797L66.1519 92.0488V71.0391H59.5283L48.5577 89.0625V71.0391H44.8318L34.7928 73.305V75.8797L40.278 76.3945V98.7435H47.2121L57.7686 81.4411V98.7435H65.5307L76.1909 85.0457ZM13.7836 95.2418H15.336C20.9245 95.2418 24.0294 91.843 24.0294 85.0455C24.0294 79.3813 21.5457 76.2915 16.8882 76.2915C16.2673 76.2915 15.3358 76.3945 13.7834 76.7035V95.2417H13.7836V95.2418ZM13.7836 107.395L18.3372 108.424V110.999H0.432792V108.424L4.57243 107.395V76.2914H0.0187988V73.7167L10.8856 70.4211H13.7837V74.1288C18.8548 71.0391 20.6143 70.5242 23.305 70.5242C29.3078 70.5242 33.8615 76.0856 33.8615 83.81C33.8615 92.6671 27.7553 98.7435 18.4407 98.7435C17.4058 98.7435 15.6463 98.6406 13.7836 98.5376",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 111,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwc);
export default __webpack_public_path__ + "static/media/pwc.05028e7c.svg";
export { ForwardRef as ReactComponent };